export enum ChannelItemDirection {
    incoming = 0,
    outgoing = 1,
}
